import { useRef, useState, useEffect } from 'react';
import './YourNotesTabs.css';
import { Settings, ChevronLeft, ChevronRight, Tune } from '@mui/icons-material';

export default function YourNotesTabs({ groups, activeGroup, onSelect, onSettings, onGroupManager }) {
    const innerRef = useRef(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);

    const visibleGroups = groups.filter((g) => g.stateId !== 2);

    // Update arrow visibility based on scroll position
    const updateArrows = () => {
        const el = innerRef.current;
        if (!el) return;
        setShowLeft(el.scrollLeft > 0);
        setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    const handleWheel = (e) => {
        const el = innerRef.current;
        if (!el) return;
        e.preventDefault();
        el.scrollBy({ left: e.deltaY * 1.5, behavior: 'smooth' });
    };

    useEffect(() => {
        const el = innerRef.current;
        if (!el) return;
        updateArrows();
        el.addEventListener('scroll', updateArrows);
        el.addEventListener('wheel', handleWheel, { passive: false });
        window.addEventListener('resize', updateArrows);
        return () => {
            el.removeEventListener('scroll', updateArrows);
            el.removeEventListener('wheel', handleWheel);
            window.removeEventListener('resize', updateArrows);
        };
    }, [visibleGroups]);

    const scrollBy = (dir) => {
        const el = innerRef.current;
        if (!el) return;
        el.scrollBy({ left: dir * 120, behavior: 'smooth' });
    };

    return (
        <div className="ynt-root">
        <div className="ynt-wrapper">
            {showLeft && (
                <button className="ynt-arrow ynt-arrow--left" onClick={() => scrollBy(-1)}>
                    <ChevronLeft sx={{ fontSize: 16 }} />
                </button>
            )}
            <div ref={innerRef} className="ynt-inner">
                {visibleGroups.map((g) => (
                    <div key={g.rk} className={`ynt-tab${activeGroup?.rk === g.rk ? ' ynt-tab--active' : ''}`} onClick={() => onSelect(g)}>
                        {activeGroup?.rk === g.rk && (
                            <Settings
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onSettings?.(g);
                                }}
                                sx={{
                                    fontSize: 12,
                                    mr: '6px',
                                    color: '#4a6a80',
                                    position: 'relative',
                                    zIndex: 1,
                                    cursor: 'pointer',
                                    '&:hover': { color: '#66b2ff' },
                                }}
                            />
                        )}
                        <span style={{ position: 'relative', zIndex: 1 }}>{g.name}</span>
                        {g.total != null && (
                            <span className="ynt-tab-total">{g.total}</span>
                        )}
                    </div>
                ))}
            </div>
            {showRight && (
                <button className="ynt-arrow ynt-arrow--right" onClick={() => scrollBy(1)}>
                    <ChevronRight sx={{ fontSize: 16 }} />
                </button>
            )}
        </div>
        <button className="ynt-manager-btn" onClick={onGroupManager}>
            <Tune sx={{ fontSize: 14 }} />
        </button>
        </div>
    );
}
